import React from "react";
import PropTypes from "prop-types";

const ModernizedInlineMessage = ({ variant, children }) => {
  const messageClasses = `modernized-inline-message-wrapper-web-sdk ${variant}`;

  return (
    <div
      className={messageClasses}
      role='alert'
      aria-live='assertive'
      data-testid='modernized-message-wrapper'
    >
      <span>{children}</span>
    </div>
  );
};

ModernizedInlineMessage.propTypes = {
  variant: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default ModernizedInlineMessage;
